import { DiagnosticCompanyStorageService } from './../../../shared/services/storage/diagnostic-company-storage.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { Subscription, of } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';
import { TreatmentService } from '../../../shared/services/treatment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingOverlayService } from '../../../shared/services/loading-overlay.service';
import { CompareWellsService } from '../../../shared/services/compare-wells.service';
import { CustomNumberDecimal1Component } from '../../../shared/components/custom-smart-table/custom-number-decimal-1.component';
import { CustomNumberDecimal3Component } from '../../../shared/components/custom-smart-table/custom-number-decimal-3.component';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { UserRolesService } from '../../../shared/services/user-roles.service';
import { DiagnosticPointsService, ChannelMappingService } from '../../../shared/services';
import { map, flatMap, finalize } from 'rxjs/operators';
import { isEmpty, isNil } from 'lodash';
import { IDiagnosticPoint } from '../../../shared/models/diagnostic-points.model';
import { ADDITIVE_UNIT_TYPE, DEFAULT_DIGIT_AFTER_DECIMAL, FLUID_UNIT_TYPE, TREATMENT_UNIT_TYPE, WELL_UNIT_TYPE } from '../../../shared/helpers/app.constants';
import { UnitSystemService } from '../../../shared/services/unit-system.service';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-well-details',
  templateUrl: './well-details.component.html',
  styleUrls: ['./well-details.component.scss']
})
export class WellDetailsComponent implements OnInit, OnDestroy {
  TREATMENT_UNIT_TYPE = TREATMENT_UNIT_TYPE;
  WELL_UNIT_TYPE = WELL_UNIT_TYPE;
  DEFAULT_DIGIT_AFTER_DECIMAL = DEFAULT_DIGIT_AFTER_DECIMAL;

  subscriptions: Subscription[] = [];
  // WellId
  wellId: number;
  companyId: string | number;
  listDiagnosticPoints: any[] = [];
  listSelectedDiagnosticPoints: any[] = [];
  selectedDiagnosticPoints: any[];

  isDataFiles: boolean = false;

  // loading: boolean = true;
  notFoundData: boolean;

  wellName: string = '';

  paramWells: any;
  // Table Proppant
  tableProppantSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    rowClassFunction: (row) => {
      if (row.data.name === 'Total Proppant (lbm)') {
        return 'column-bold';
      } else {
        return 'column-normal';
      }
    },
    attr: {
      class: 'last-column-text-right',
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      no: {
        title: 'No.',
        type: 'string',
        width: '8%',
        sort: false,
      },
      name: {
        title: 'Name',
        type: 'string',
        width: '62%',
        sort: false,
      },
      strap: {
        title: 'Actual',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantity: {
        title: 'Metered',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantityFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };
  // Table Additive
  tableAdditiveSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    attr: {
      class: 'last-column-text-right',
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      no: {
        title: 'No.',
        type: 'string',
        width: '8%',
        sort: false,
      },
      name: {
        title: 'Name',
        type: 'string',
        width: '47%',
        sort: false,
      },
      kind: {
        title: 'Kind',
        type: 'string',
        width: '15%',
        sort: false,
      },
      strap: {
        title: 'Actual',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantity: {
        title: 'Metered',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      quantityFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };
  // Table Fluid
  tableFluidSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    rowClassFunction: (row) => {
      if (row.data.name === 'Total Fluid (bbl)') {
        return 'column-bold';
      } else {
        return 'column-normal';
      }
    },
    attr: {
      class: 'last-column-text-right',
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      no: {
        title: 'No.',
        type: 'string',
        width: '8%',
        sort: false,
      },
      name: {
        title: 'Name',
        type: 'string',
        width: '47%',
        sort: false,
      },
      kind: {
        title: 'Kind',
        type: 'string',
        width: '15%',
        sort: false,
      },
      strap: {
        title: '',
        type: 'string',
        class: 'text-right',
        width: '12%',
        sort: false,
      },
      fluidVol: {
        title: 'Volume',
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal1Component,
        width: '12%',
        sort: false,
      },
      fluidVolFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };
  // Table Tubular
  tableTubularSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    hideSubHeader: true,
    attr: {
      class: 'last-column-text-right',
    },
    pager: {
      perPage: 15,
    },
    columns: {
      topMD: {
        title: `Top MD ${this.getUnitConveter(WELL_UNIT_TYPE.topMD, 'ft')}`,
        type: 'custom',
        renderComponent: CustomNumberDecimal1Component,
        width: '8%',
        sort: false,
      },
      bottomMD: {
        title: `Bottom MD ${this.getUnitConveter(WELL_UNIT_TYPE.bottomMD, 'ft')}`,
        type: 'custom',
        renderComponent: CustomNumberDecimal1Component,
        width: '47%',
        sort: false,
      },
      kind: {
        title: 'Type',
        type: 'string',
        width: '15%',
        sort: false,
      },
      od: {
        title: `OD ${this.getUnitConveter(WELL_UNIT_TYPE.OD, 'in')}`,
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal3Component,
        width: '12%',
        sort: false,
      },
      id: {
        title: `ID ${this.getUnitConveter(WELL_UNIT_TYPE.ID, 'in')}`,
        type: 'custom',
        class: 'text-right',
        renderComponent: CustomNumberDecimal3Component,
        width: '12%',
        sort: false,
      },
      fluidVolFake: {
        title: '',
        type: 'string',
        width: '6%',
        sort: false,
      },
    },
  };

  dataProppant: LocalDataSource = new LocalDataSource();
  dataAdditive: LocalDataSource = new LocalDataSource();
  dataFluid: LocalDataSource = new LocalDataSource();
  dataTubular: LocalDataSource = new LocalDataSource();

  constructor(
    private treatmentService: TreatmentService,
    private route: ActivatedRoute,
    private loadingOverlayService: LoadingOverlayService,
    private compareWellsService: CompareWellsService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private diagnosticPointsService: DiagnosticPointsService,
    private diagnosticCompanyStorageService: DiagnosticCompanyStorageService,
    private router: Router,
    private unitSystemService: UnitSystemService
  ) {
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    this.companyId = userInfo.companyId || '';
    if (this.userAuthService.isCarboUser()) {
      if (!this.userRolesService.isFieldEngineer(userRole)) {
        this.isDataFiles = true;
      }
    } else if (!this.userRolesService.isFieldEngineer(userRole)) {
      this.isDataFiles = userInfo.canHaveDataFiles;
    }
  }

  ngOnInit() {
    this.loadingOverlayService.show();
    this.subscriptions.push(
      this.route.params.subscribe((params: any) => {
        const id = +params.id;
        if (typeof id === 'number' && !isNaN(id)) {
          this.wellId = id;
          this.getWellSummary(id);
        } else {
          this.notFoundData = false;
          this.loadingOverlayService.hide();
        }
      })
    );
  }

  loadDiagnosticPoints(): void {
    this.subscriptions.push(
      this.getListDiagnosticPoints(this.companyId).pipe(flatMap(data => {
        if (!isEmpty(data)) {
          this.listDiagnosticPoints = data.map(item => {
            item.id = item.id;
            item.text = item.name;
            return item;
          });
        }
        if (this.selectedDiagnosticPoints !== undefined) {
          return of(this.selectedDiagnosticPoints);
        } else {
          return this.getSelectedDiagnosticPoints(this.wellId);
        }
      })).subscribe(data => {
        if (!isEmpty(data)) {
          this.listSelectedDiagnosticPoints = this.listDiagnosticPoints.filter(item => {
            return data.includes(item.id);
          });
        }
      })
    );
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  changeTreatmentData() {
    this.router.navigate(['pages/wells/treatmentDetails', this.wellId], {
      queryParams: { wellName: this.wellName, wellUid: this.paramWells.wellUid, serviceCompanyName: this.paramWells.serviceCompanyName, operatorName: this.paramWells.operatorName }
    });
  }

  navigateToDataFlies() {
    this.router.navigate(['pages/wells/dataFiles'], {
      queryParams: { wellId: this.wellId, wellName: this.wellName, serviceCompanyName: this.paramWells.serviceCompanyName, operatorName: this.paramWells.operatorName }
    });
  }

  getWellSummary(id: any) {
    this.subscriptions.push(
      this.compareWellsService.getWellSummary(id)
      .pipe(
        finalize(() => {
          this.loadDiagnosticPoints();
        })
      )
        .subscribe(
        (res) => {
          this.wellName = res.result.wellName;
          this.paramWells = res.result;
          if (res.result.diagnostics !== undefined) {
            this.selectedDiagnosticPoints = res.result.diagnostics ? res.result.diagnostics : [];
          }
          let unit: string;
          // Proppant
          unit = this.getUnitConveter(TREATMENT_UNIT_TYPE.mass, 'lbm');
          this.dataProppant.load(res.result.proppant.map((item, index) => {
            if (item.name === 'Total Proppant (lbm)') {
              item.name = `Total Proppant ${unit}`;
              return {
                no: 'All', name: item.name,
                strap: this.convertUnit(TREATMENT_UNIT_TYPE.stMass, item.stMass, DEFAULT_DIGIT_AFTER_DECIMAL.stMass),
                quantity: this.convertUnit(TREATMENT_UNIT_TYPE.mass, item.mass, DEFAULT_DIGIT_AFTER_DECIMAL.mass) 
              };
            }
            return {
              no: index,
              name: (`${item.name} ${unit}`),
              strap: this.convertUnit(TREATMENT_UNIT_TYPE.stMass, item.stMass, DEFAULT_DIGIT_AFTER_DECIMAL.stMass),
              quantity: this.convertUnit(TREATMENT_UNIT_TYPE.mass, item.mass, DEFAULT_DIGIT_AFTER_DECIMAL.mass) 
            };
          }));
          // Additive
          unit = this.getUnitConveter(ADDITIVE_UNIT_TYPE.mass, 'lbm');
          const volUnit = this.getUnitConveter(ADDITIVE_UNIT_TYPE.volume, 'gal');
          this.dataAdditive.load(res.result.additive.map((item, index) => {
            let strap = this.convertUnit(ADDITIVE_UNIT_TYPE.stMass, item.stMass, DEFAULT_DIGIT_AFTER_DECIMAL.stMass);
            if (item.stVol > 0) {
              strap = this.convertUnit(ADDITIVE_UNIT_TYPE.stVol, item.stVol, DEFAULT_DIGIT_AFTER_DECIMAL.stVol);
            }
            if (item && item.mass) {
              return {
                no: (index + 1),
                name: `${item.name} ${unit}`,
                kind: item.kind,
                strap: strap,
                quantity: this.convertUnit(ADDITIVE_UNIT_TYPE.mass, item.mass, DEFAULT_DIGIT_AFTER_DECIMAL.mass)
              };
            } else {
              return {
                no: (index + 1),
                name: `${item.name} ${volUnit}`,
                kind: item.kind,
                strap: strap,
                quantity: this.convertUnit(ADDITIVE_UNIT_TYPE.volume, item.volume, DEFAULT_DIGIT_AFTER_DECIMAL.volume) 
              };
            }
          }));
          // Fluid
          unit = this.getUnitConveter(FLUID_UNIT_TYPE.volume, 'bbl');
          this.dataFluid.load(res.result.fluid.map((item, index) => {
            if (item.name === 'Total Fluid (bbl)') {
              item.name = `Total Fluid ${unit}`;
              return {
                no: 'All',
                name: item.name,
                kind: item.kind,
                strap: '',
                fluidVol: this.convertUnit(FLUID_UNIT_TYPE.volume, item.fluidVol, DEFAULT_DIGIT_AFTER_DECIMAL.fluidVol) 
              };
            }
            return {
              no: index,
              name: `${item.name} ${unit}`,
              kind: item.kind,
              strap: '',
              fluidVol: this.convertUnit(FLUID_UNIT_TYPE.volume, item.fluidVol, DEFAULT_DIGIT_AFTER_DECIMAL.fluidVol) 
            };
          }));

          this.dataTubular.load(res.result.tubular.map((item, index) => {
            return {
              bottomMD: this.convertUnit(WELL_UNIT_TYPE.bottomMD, item.bottomMD, DEFAULT_DIGIT_AFTER_DECIMAL.bottomMD),
              bottomTVD: this.convertUnit(WELL_UNIT_TYPE.bottomTVD, item.bottomTVD, DEFAULT_DIGIT_AFTER_DECIMAL.bottomTVD),
              id: this.convertUnit(WELL_UNIT_TYPE.ID, item.id, DEFAULT_DIGIT_AFTER_DECIMAL.ID),
              kind: item.kind,
              od: this.convertUnit(WELL_UNIT_TYPE.OD, item.od, DEFAULT_DIGIT_AFTER_DECIMAL.OD),
              topMD: this.convertUnit(WELL_UNIT_TYPE.topMD, item.topMD, DEFAULT_DIGIT_AFTER_DECIMAL.topMD),
              topTVD: this.convertUnit(WELL_UNIT_TYPE.topTVD, item.topTVD, DEFAULT_DIGIT_AFTER_DECIMAL.topTVD),
              fluidVolFake: item.fluidVolFake
            };
          }));
          this.notFoundData = true;
          this.loadingOverlayService.hide();
        }, (error) => {
          this.notFoundData = false;
          this.loadingOverlayService.hide();
        }
      )
    );
  }

  getListDiagnosticPoints(companyId) {
    const companyStorage = this.diagnosticCompanyStorageService.getCompanyStorage(companyId);
    if (companyStorage) {
      return of(Object.values(companyStorage));
    } else {
      return this.diagnosticPointsService.getByCompany(companyId)
        .pipe(map(res => {
          this.diagnosticCompanyStorageService.setCompanyStorage(companyId, res.result);
          return res.result;
        }));
    }
  }

  getSelectedDiagnosticPoints(wellId) {
    return this.diagnosticPointsService.getByWell(wellId).pipe(map(res => {
      return res.result;
    }));
  }

  selectDiagnosticPointHandler(diagId: number) {
    if (this.wellId && diagId) {
      console.log(diagId);
      const sub = this.diagnosticPointsService.addByWell(this.wellId, { id: diagId }).subscribe(res => res);
      this.subscriptions.push(sub);
    }
  }

  removeDiagnosticPointHandler(diagId: number) {
    if (this.wellId && diagId) {
      const sub = this.diagnosticPointsService.deleteByWell(this.wellId, diagId).subscribe(res => res);
      this.subscriptions.push(sub);
    }
  }

  getUnitConveter(measureType: string, curUnit: string): string {
    if (isNil(measureType) || !measureType.length) return curUnit ? `(${curUnit})` : '';
    else {
      const unit = this.unitSystemService.getUnit(measureType, undefined, curUnit);
      return unit ? `(${unit})` : '';
    }
  }

  convertUnit(measureType: string, value, decimal?: number): number | string {
    return this.unitSystemService.getValueConvert(measureType, value, decimal);
  }

}
